export default "__VITE_ASSET__d5a7451e__"